/* global $ */
import datepickerTranslations from '../src/translations/datepicker';
import config from '.';

$.extend($.fn.pickadate.defaults, datepickerTranslations[config.i18nLng]);
